const listChecklistItem = {
  primary: 'No questions section'
};

export default listChecklistItem;
